import { Button } from 'reactstrap';
import styled from 'styled-components';

export const CloseMultiplesChatsButtonAltIcon = styled(Button)`
  &:hover {
    transform: scale(1.1);
  }
`;
